import groq from "groq";
import { officeRouteSlugFromParentOfficeID } from "./utils/office-route-slug";

const MetricsQuery = groq`
{
  "errors": {
    "offices": {
      "missing": select(
        count(*[_type == "office" && (
          !defined(phone) || 
          !defined(phoneAlt) ||
          !defined(address.name) ||
          !defined(address.country) ||
          !defined(address.addressLine1) ||
          !defined(address.city) ||
          !defined(address.stateProvince) ||
          !defined(address.postalCode) ||
          !defined(geoCoordinates.lat) ||
          !defined(geoCoordinates.lng) ||
          !defined(urlSlug)
        )]) > 0 => {
          "phone": count(*[_type == "office" && !defined(phone)]),
          "phoneAlt": count(*[_type == "office" && !defined(phoneAlt)]),
          "address": {
            "name": count(*[_type == "office" && !defined(address.name)]),
            "country": count(*[_type == "office" && !defined(address.country)]),
            "addressLine1": count(*[_type == "office" && !defined(address.addressLine1)]),
            "city": count(*[_type == "office" && !defined(address.city)]),
            "stateProvince": count(*[_type == "office" && !defined(address.stateProvince)]),
            "postalCode": count(*[_type == "office" && !defined(address.postalCode)])
          },
          "geoCoordinates": count(*[_type == "office" && (!defined(geoCoordinates.lat) || !defined(geoCoordinates.lng))]),
          "urlSlug": count(*[_type == "office" && !defined(urlSlug)])
        },
        {}
      )
    }
  },
  "metrics": {
    "franchises": {
      "count": count(*[_type == "franchiseOrganization"]),
      "active": count(*[_type == "franchiseOrganization" && active == true]),
      "inactive": count(*[_type == "franchiseOrganization" && active != true]),
      "with": {
        "offices": count(*[_type == "franchiseOrganization" && defined(offices) && count(offices) > 0])
      },
      "without": {
        "offices": count(*[_type == "franchiseOrganization" && (!defined(offices) || count(offices) == 0)])
      }
    },
    "offices": {
      "count": count(*[_type == "office"]),
      "enabled": count(*[_type == "office" && enabled == true]),
      "disabled": count(*[_type == "office" && enabled != true]),
      "with": {
        "reviews": count(*[_type == "office" && count(*[_type == "officeReview" && references(^._id)]) > 0]),
        "homePages": {
          "count": count(*[_type == "office" && count(*[_type == "routeNode" && defined(page._ref) && slug.current == ${officeRouteSlugFromParentOfficeID} && count(context[_type == "officeRef" && references(^.^._id)]) > 0]) > 0]),
          "enabled": count(*[_type == "office" && count(*[_type == "routeNode" && isEnabled == true && defined(page._ref) && slug.current == ${officeRouteSlugFromParentOfficeID} && count(context[_type == "officeRef" && references(^.^._id)]) > 0]) > 0]),
          "disabled": count(*[_type == "office" && count(*[_type == "routeNode" && isEnabled != true && defined(page._ref) && slug.current == ${officeRouteSlugFromParentOfficeID} && count(context[_type == "officeRef" && references(^.^._id)]) > 0]) > 0])
        }
      },
      "without": {
        "reviews": count(*[_type == "office" && count(*[_type == "officeReview" && references(^._id)]) == 0]),
        "homePages": count(*[_type == "office" && count(*[_type == "routeNode" && defined(page._ref) && slug.current == ${officeRouteSlugFromParentOfficeID} && count(context[_type == "officeRef" && references(^.^._id)]) > 0]) == 0])
      }
    }
  }
}`;

export { MetricsQuery };
